import { useEffect } from "react";
import { App as CapacitorApp } from "@capacitor/app";
import { useNavigate, useLocation } from "react-router-dom";

export default function BackHandler() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handler = CapacitorApp.addListener("backButton", ({ canGoBack }) => {
      // Si hay historial en React Router → volver atrás
      if (canGoBack || location.pathname !== "/") {
        navigate(-1);
      } else {
        // Si ya estás en la raíz, puedes salir (o ignorar)
        CapacitorApp.exitApp(); // 👈 cierra la app
        // O comentar la línea de arriba si no quieres salir nunca
      }
    });

    return () => {
      handler.then(h => h.remove());
    };
  }, [navigate, location]);

  return null; // no renderiza nada, solo controla back
}
